// ChatWindow.js
import React, { useEffect, useRef } from 'react';
import './App.css'//We'll add styles here

export default function ChatWindow({ messages }) {
  const chatRef = useRef(null);

  // Scroll to bottom on new messages
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="chat-window" ref={chatRef}>
      {messages.map((msg, idx) => (
        <div
          key={idx}
          className={`message ${msg.isUser ? 'user' : 'bot'}`}
          aria-label={msg.isUser ? 'User message' : 'Bot message'}
        >
          <p>{msg.text}</p>
        </div>
      ))}
    </div>
  );
}
